import React from 'react';

const Image = ({ src, type, alt = '', useNoPhoto, modifyTime = '', className = '' }) => {
	const noPhotoSrc = '/assets/images/module/photo_l.gif';
	const imgServerURL = process.env.REACT_APP_IMG_SERVER;

	let resultSrc = '';

	if (useNoPhoto) {
		resultSrc = noPhotoSrc;
	} else {
		let params = '';

		// list_premium, mobile_list_premium 케이스 사용없음 => 사용시 워터마크 경로 및 사이즈 수정필요
		switch (type.toLowerCase()) {
			case 'list_premium':
				params = `?downsize=185px:*&crop=185px:138px;right,bottom&composite=right,bottom|${imgServerURL}/wt_mark/w_mark_03.png?resize=68.2px:18.7px`;
				break;

			// case 'mobile_list':
			// 	params = `?downsize=320px:*&crop=320px:240px;right,bottom&composite=right,bottom|
			// 	${imgServerURL}/wt_mark/w_mark_03.png?resize=118px:32.5p`;
			// 	break;

			case 'mobile_list':
				params = `?impolicy=heightRate&rh=384&cw=640&ch=384&cg=Center&wtmk=${imgServerURL}/wt_mark/w_mark_04.png`;
				break;

			case 'mobile_list_premium':
				params = `?downsize=640px:*&crop=640px:480px;right,bottom&composite=right,bottom|${imgServerURL}/wt_mark/w_mark_03.png`;
				break;
			default:
		}

		if (modifyTime !== '') params = `${params}&t=${modifyTime}`;

		resultSrc = `${imgServerURL}/carpicture${src}${params}`;
	}

	return (
		<img
			className={className}
			src={resultSrc}
			alt={alt}
		/>
	);
};

export default Image;
